import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  margin: 10px 0;
`

export const ErrorText = styled.span`
  color: #a63232;
`
